export default {"src":"/_next/static/media/calendarRedesign.dd012664.svg","height":24,"width":24};